var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('loading',{attrs:{"active":_vm.is_loading},on:{"update:active":function($event){_vm.is_loading=$event}}}),_c('Product',{directives:[{name:"show",rawName:"v-show",value:(!_vm.is_loading),expression:"!is_loading"}],attrs:{"id":_vm.idProducto},on:{"loader":_vm.changeLoader}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }